import React from 'react'

const HelpAndSupportRoute = ({children}) => {
  return children
}

export default HelpAndSupportRoute